import { createAction } from 'redux-actions';

const filterActions = {
  INIT_HOTEL_FILTER: 'INIT_HOTEL_FILTER',
  INIT_HOTEL_FILTER_V2: 'INIT_HOTEL_FILTER_V2',
  FILTER_APPLYING: 'FILTER_APPLYING',
  INIT_HOTEL_FILTER_COMPLETED: 'INIT_HOTEL_FILTER_COMPLETED',
  UPDATE_HOTEL_FILTER: 'UPDATE_HOTEL_FILTER',
  UPDATE_HOTEL_FILTER_COMPLETED: 'UPDATE_HOTEL_FILTER_COMPLETED',
  UPDATE_FLIGHT_FILTER: 'UPDATE_FLIGHT_FILTER',
  CLEAR_HOTEL_FILTER: 'CLEAR_HOTEL_FILTER',
  UPDATE_HOTEL_CURRENCY: 'UPDATE_HOTEL_CURRENCY',
  INIT_HOTEL_BOOKING_FILTER: 'INIT_HOTEL_BOOKING_FILTER',
  UPDATE_CLIENT_FILTER: 'UPDATE_CLIENT_FILTER',
  UPDATE_BIG_POINTS: 'UPDATE_BIG_POINTS',
  DISABLE_DROPOUT_ALERT: 'DISABLE_DROPOUT_ALERT',

  // analytics events
  UPDATE_HOTEL_FILTER_ANALYTIC_EVENT: 'UPDATE_HOTEL_FILTER_ANALYTIC_EVENT',
  UPDATE_FLIGHT_HOTEL_FILTER_ANALYTIC_EVENT:
    'UPDATE_FLIGHT_HOTEL_FILTER_ANALYTIC_EVENT',
  CLICK_PRICE_FILTER: 'CLICK_PRICE_FILTER',
  TRACK_APPLY_FILTER: 'TRACK_APPLY_FILTER',
};

const actionCreators = {
  initHotelFilter: createAction(filterActions.INIT_HOTEL_FILTER),
  initHotelFilterV2: createAction(filterActions.INIT_HOTEL_FILTER_V2),
  initHotelFilterCompleted: createAction(
    filterActions.INIT_HOTEL_FILTER_COMPLETED
  ),
  updateHotelFilterAnalyticEvent: createAction(
    filterActions.UPDATE_HOTEL_FILTER_ANALYTIC_EVENT
  ),
  applyingHotelFilter: createAction(filterActions.FILTER_APPLYING),
  updateHotelFilter: createAction(filterActions.UPDATE_HOTEL_FILTER),
  updateHotelFilterCompleted: createAction(
    filterActions.UPDATE_HOTEL_FILTER_COMPLETED
  ),
  initHotelBookingFilter: createAction(filterActions.INIT_HOTEL_BOOKING_FILTER),
  updateFlightHotelFilterAnalyticEvent: createAction(
    filterActions.UPDATE_FLIGHT_HOTEL_FILTER_ANALYTIC_EVENT
  ),
  updateFlightFilter: createAction(filterActions.UPDATE_FLIGHT_FILTER),
  clearHotelFilter: createAction(filterActions.CLEAR_HOTEL_FILTER),
  updateHotelCurrency: createAction(filterActions.UPDATE_HOTEL_CURRENCY),
  updateClientFilter: createAction(filterActions.UPDATE_CLIENT_FILTER),
  updateBigPointFilter: createAction(filterActions.UPDATE_BIG_POINTS),
  disableDropoutAlert: createAction(filterActions.DISABLE_DROPOUT_ALERT),
  trackClickOnPriceFilter: createAction(filterActions.CLICK_PRICE_FILTER),
  trackApplyFilter: createAction(filterActions.TRACK_APPLY_FILTER),
};

export { filterActions as types, actionCreators };
